import './realisation-sticky-bar.scss';

const openPdfPopup = (popup: HTMLElement, pdfUrl: string) => {
    const input = document.querySelector<HTMLInputElement>('#input_7_20');
    if (input) input.value = pdfUrl;

    popup.classList.add('open');
    popup.setAttribute('aria-hidden', 'false');
};

const closePdfPopup = (popup: HTMLElement) => {
    popup.classList.remove('open');
    popup.setAttribute('aria-hidden', 'true');
};

const initStickyBar = () => {
    const ctas = document.querySelector<HTMLElement>('[data-realisation-hero-ctas]');
    const bar  = document.querySelector<HTMLElement>('[data-realisation-sticky-bar]');

    if (ctas && bar) {
        const observer = new IntersectionObserver(
            ([entry]) => {
                const visible = !entry.isIntersecting;
                bar.classList.toggle('is-visible', visible);
                bar.setAttribute('aria-hidden', String(!visible));
            },
            { root: null, threshold: 0 }
        );

        observer.observe(ctas);
    }

    document.querySelectorAll<HTMLAnchorElement>('.btn-realisation-contact').forEach(btn => {
        btn.addEventListener('click', (e) => {
            const formsBlock = document.querySelector<HTMLElement>('.block.forms');
            if (!formsBlock) return;
            e.preventDefault();
            formsBlock.scrollIntoView({ behavior: 'smooth' });
        });
    });

    // PDF download popup
    const pdfPopup = document.querySelector<HTMLElement>('#popup-pdf');

    if (pdfPopup) {
        document.querySelectorAll<HTMLElement>('.btn-pdf-download').forEach(btn => {
            btn.addEventListener('click', () => openPdfPopup(pdfPopup, btn.dataset.pdfUrl ?? ''));
        });

        pdfPopup.querySelector<HTMLButtonElement>('.btn--close')?.addEventListener('click', () => {
            closePdfPopup(pdfPopup);
        });

        pdfPopup.addEventListener('click', (e) => {
            if (e.target === pdfPopup) closePdfPopup(pdfPopup);
        });
    }
};

initStickyBar();
